import React from 'react';
import ReactDOM from 'react-dom';
import ActivateAccount from './components/ActivateAccount';

ReactDOM.render(
  <React.StrictMode>
    <ActivateAccount />
  </React.StrictMode>,
  document.getElementById('root')
);
